"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeAssetRepo = exports.AssetRepo = void 0;
const ObservableEntity_1 = require("./ObservableEntity");
class AssetRepo extends ObservableEntity_1.ObservableEntity {
}
exports.AssetRepo = AssetRepo;
function makeAssetRepo() {
    return new AssetRepoImp();
}
exports.makeAssetRepo = makeAssetRepo;
class AssetRepoImp extends AssetRepo {
    get assets() {
        return [...this._assets];
    }
    addAsset(asset) {
        const newAssets = this._assets.filter(existingAsset => existingAsset.id !== asset.id);
        newAssets.push(asset);
        this._assets = [...newAssets];
        this.notify();
    }
    removeAsset(id) {
        let foundAsset = false;
        this._assets.forEach(asset => {
            if (asset.id === id) {
                foundAsset = true;
            }
        });
        if (foundAsset) {
            this._assets = this._assets.filter(asset => asset.id !== id);
            this.notify();
        }
    }
    hasAsset(id) {
        let hasAsset = false;
        this._assets.forEach(asset => {
            if (asset.id === id) {
                hasAsset = true;
            }
        });
        return hasAsset;
    }
    getAssetByID(id) {
        let foundAsset;
        this._assets.forEach(asset => {
            if (asset.id === id) {
                foundAsset = asset;
            }
        });
        return foundAsset;
    }
    constructor() {
        super();
        this._assets = [];
    }
}
